export default {
    setEventList (state, { eventList }) {
        state.eventList = eventList
    },
    setMainEvent (state, { mainEvent }) {
        state.mainEvent = mainEvent
    },
    setTalkEvents (state, { talkEvent }) {
        state.talkEvents = talkEvent
    },
    setLiveEvents (state, { liveEvent }) {
        state.liveEvents = liveEvent
    },
    setTalkExperts (state, { exp }) {
        state.expertsTalk = exp
    },
    setLiveExperts (state, { exp }) {
        state.expertsLive = exp
    },
    setUserEvents (state, { events }) {
        state.userEvents = events
    },
    setSelectedEvent (state, { event }) {
        state.selectedEvent = event
    },
    setCorpPrivateVideos (state, { videos }) {
        state.corpPrivateVideos = videos
    },
    setEventUsers (state, { users }) {
        state.eventUsers = users
    },
    setUserSig (state, { sig }) {
        state.userSig = sig
    },
    setUnAuthUserSig (state, { sig }) {
        state.unAuthUserSig = sig
    },
    setUserStatus (state, { isAnyony }) {
        state.isUserAnonymous = isAnyony
    },
    setDemoUserStatus (state, isAnyony) {
        state.demoUserStatus = isAnyony
    },
    setLiveEventsArchive (state, { liveArchive }) {
        state.liveEventsArchive = liveArchive
    },
    setCorpArchiveEvents (state, { aEvents }) {
        state.corpArchiveEvents = aEvents
    },
    setBannerEvent (state, eventId) {
        state.bannerEvent = eventId
    },
    setArchivePlaylist (state, {arplaylist}) {
        state.archivePlaylist = arplaylist
    },
    setMonthEvents (state, {monEvents}) {
        state.monthEvents = monEvents
    },
    setCorpMainEvent (state, {pEvents}) {
        state.corpMainEvent = pEvents
    },
    setCorpAllEvents (state, {pEvents}) {
        state.corpAllEvents = pEvents
    },
    setCorpPrivateEvents (state, {pEvents}) {
        state.corpPrivateEvents = pEvents
    },
    setCorpPublicEvents (state, {pEvents}) {
        state.corpPublicEvents = pEvents
    },
    setCorpPlaylists (state, {playlist}) {
        state.corpPlaylists = playlist
    },
    setDemoEvent (state, {event}) {
        state.demoEvent = event
    },
    setUpcomingEvent (state, {event}) {
        state.upcomingEvent = event
    }
}



// WEBPACK FOOTER //
// ./src/store/events/mutations.js